export const mediaTypes = {
  audio: 'audio',
  video: 'video',
  image: 'image',
  transcription: 'transcription',
  pdf: 'pdf'
};
